var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#667085",
    d: "M15 9.143v5.515h-3.229V9.48c0-1.278-.47-2.152-1.614-2.152-.874 0-1.413.605-1.614 1.143-.068.202-.135.471-.135.807v5.382H5.18s.068-8.745 0-9.62h3.23v1.346c.403-.673 1.21-1.614 2.891-1.614 2.086 0 3.7 1.412 3.7 4.372M1.816.398C.74.398 0 1.138 0 2.08s.673 1.682 1.749 1.682c1.143 0 1.816-.74 1.816-1.682C3.632 1.071 2.96.398 1.816.398M.202 14.658H3.43V5.04H.202z"
  })));
};
export default SvgLinkedin;